import type { State, ListSortInfo, ListPageInfo, ProductInfo } from './state'

import state, { ListTypeEnum, ListStatusEnum } from './state'
import actionTypes from './actionTypes'
import actions from './actions'
import mutations from './mutations'

export {
  State,
  actionTypes,
  ListTypeEnum,
  ListStatusEnum,
  ListSortInfo,
  ListPageInfo,
  ProductInfo,
}

export default {
  namespace: true,
  state,
  actions,
  mutations,
}
